var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0405 7.19L12.0004 12.42L2.96045 7.19C3.36045 6.45 3.94045 5.8 4.59045 5.44L9.93045 2.48C11.0704 1.84 12.9304 1.84 14.0704 2.48L19.4104 5.44C20.0604 5.8 20.6405 6.45 21.0405 7.19Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.0006 12.4204V22.0004C11.2506 22.0004 10.5006 21.8404 9.93062 21.5204L4.59063 18.5604C3.38063 17.8904 2.39062 16.2104 2.39062 14.8304V9.17043C2.39062 8.53043 2.61062 7.83043 2.96062 7.19043L12.0006 12.4204Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6105 9.17043V14.8304C21.6105 16.2104 20.6205 17.8904 19.4105 18.5604L14.0705 21.5204C13.5005 21.8404 12.7505 22.0004 12.0005 22.0004V12.4204L21.0405 7.19043C21.3905 7.83043 21.6105 8.53043 21.6105 9.17043Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.0f72524fa8c2fea86cd278d0ad07b395.svg";
export { ForwardRef as ReactComponent };